module.exports = __webpack_public_path__ + "assets/img/block-95451d8e.png";